import React, { useCallback, useState } from 'react';
import { KycIntroModal, type KycIntroVariant } from '../components/KycIntroModal';
import type { AdyenAccount } from '../services/api';

/** Where the Hantverkare starts KYC from; completing todos have a short variant. */
export type KycEntry = 'kyc' | 'capabilities' | 'bankAccount';

/**
 * The information step for an entry (ClickUp 869fncme5): the short variant
 * when Adyen needs more (capabilities, bank account) or the onboarding is
 * already completed, otherwise the full one.
 */
export function kycIntroVariant(account: AdyenAccount | null, entry: KycEntry): KycIntroVariant {
  if (entry === 'bankAccount' || entry === 'capabilities') return entry;
  return account?.onboardingCompletedAt ? 'capabilities' : 'start';
}

/**
 * The information step before every KYC start: `open` shows it, and only its
 * "Fortsätt" runs the start the entry had before (start(), the mock handling,
 * window.open and messages). Nothing is stored, so it shows every time.
 */
export function useKycIntro() {
  const [intro, setIntro] = useState<{ variant: KycIntroVariant; onContinue: () => void } | null>(null);
  const open = useCallback((variant: KycIntroVariant, onContinue: () => void) => {
    setIntro({ variant, onContinue });
  }, []);
  const modal = intro ? (
    <KycIntroModal
      variant={intro.variant}
      onClose={() => setIntro(null)}
      onContinue={() => {
        setIntro(null);
        intro.onContinue();
      }}
    />
  ) : null;
  return { open, modal };
}
